"use client"

import Image from "next/image"

import iconStats1024Img from "@packages/base/assets/icon-stats-1024.png"
import { useConfig } from "@packages/web/components/ConfigProvider"

const ICON_CLASS_BY_SIZE = {
  28: "size-7",
  32: "size-8",
  40: "size-10",
} as const

export default function BackofficeBrand({
  iconSize = 40,
}: {
  iconSize?: 28 | 32 | 40
}) {
  const { COMPANY_TITLE } = useConfig()
  const title = COMPANY_TITLE?.trim() || "Ernest"

  return (
    <div className="ml-1.5 flex items-center gap-2">
      <Image
        alt=""
        className={`${ICON_CLASS_BY_SIZE[iconSize]} shrink-0 object-contain`}
        height={iconSize}
        src={iconStats1024Img}
        width={iconSize}
      />
      <span className="text-sm font-semibold text-ink">{title}</span>
      <span className="text-sm italic text-nav-muted">backoffice</span>
    </div>
  )
}
